import { Components, inputBaseClasses, Theme } from '@mui/material';
import { Content, Disabled, Surface } from '../color';
import { body1, body2 } from '../typography/jscss';
import {
  baseSpace, Spacing3, Spacing4, Spacing5,
} from '../spacing';

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    root: {
      ...body1,
      color: Content.main,
      backgroundColor: Surface.main,
      [`.${inputBaseClasses.input}`]: {
        height: 24,
        lineHeight: '24px',
        paddingInline: Spacing5,
        paddingBlock: Spacing3,
        '::placeholder': {
          color: Content.tertiary,
        },
      },
      [`&.${inputBaseClasses.disabled}`]: {
        backgroundColor: Disabled.default.main,
        color: Disabled.default.text,
      },
      [`&.${inputBaseClasses.readOnly}`]: {
        backgroundColor: Surface.dark,
      },
      [`&.${inputBaseClasses.multiline}`]: {
        padding: 0,
      },
    },
    adornedStart: {
      [`.${inputBaseClasses.input}`]: {
        paddingLeft: 0,
      },
    },
    adornedEnd: {
      [`.${inputBaseClasses.input}`]: {
        paddingRight: 0,
      },
    },
    sizeSmall: {
      ...body2,
      [`.${inputBaseClasses.input}`]: {
        height: 20,
        lineHeight: '20px',
        paddingBlock: baseSpace * 1.5,
      },
    },
    readOnly: {
      [`.${inputBaseClasses.input}`]: {
        backgroundColor: Surface.dark,
      },
    },
  },
  variants: [
    {
      props: {
        size: 'large',
      },
      style: {
        [`.${inputBaseClasses.input}`]: {
          paddingBlock: Spacing4,
        },
      },
    },
  ],
};
